export function getIconPath(icon) {
  try {
    return require(`@/assets/icons/${icon}.svg`);
  } catch (error) {
    console.warn(`Icon not found: ${icon}.svg`, error);
    return null;
  }
}

export const getImgPath = getIconPath;

export function getAssetsPath(path) {
  try {
    return require(`@/assets/${path}`);
  } catch (error) {
    console.warn(`assets not found: ${path}`, error);
    return null;
  }
}
